// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Hc6P","left":"styles_left__1Qxiy","desktopActions":"styles_desktopActions__-B7qC","title":"styles_title__2jfMc"};